export default {
    smsRemain: state => state.smsRemain,
    smsCountHistory: state => state.smsCountHistory,
    smsCount: state => state.smsCount,
}
